import { apiClient } from './api-client'

export interface UpdateProfileDto {
  firstName?: string
  lastName?: string
  email?: string
  oabNumber?: string
  oabState?: string
}

export interface UserProfile {
  id: string
  email: string
  firstName: string
  lastName: string
  role: string
  permissions: string[]
  isActive: boolean
  emailVerified: boolean
  oabNumber?: string
  oabState?: string
}

export interface TokenPair {
  accessToken: string
  refreshToken: string
  expiresIn: number
}

class AuthService {
  private readonly baseUrl = '/api/auth'

  async getProfile(): Promise<UserProfile> {
    const response = await apiClient.get(`${this.baseUrl}/profile`)
    return response.data.data.user
  }

  async updateProfile(updateData: UpdateProfileDto): Promise<UserProfile> {
    const response = await apiClient.put(`${this.baseUrl}/profile`, updateData)
    return response.data.data.user
  }

  /**
   * Refresh access token using refresh token
   */
  async refreshToken(refreshToken: string): Promise<TokenPair> {
    const response = await apiClient.post(`${this.baseUrl}/refresh`, {
      refreshToken
    })
    return response.data.data.tokens
  }
}

export const authService = new AuthService()
